import { create } from 'apisauce';

const headers = {
  'content-type': 'application/json',
  'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
  'X-Requested-With': 'XMLHttpRequest',
};

export const api = create({
  baseURL: process.env.REACT_APP_AP_URL,
  headers,
});
